import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import env from '.env.json';

const ChatHeader = ({ toggleChat }) => (
  <div className="px-1 border-bottom d-flex justify-content-between align-items-center text-white" style={{ background: '#10CAF0' }}>
    <div className="d-flex align-items-center">
      <img
        alt="logo"
        style={env.DEFAULT_LOCALE == 'vi' ? { width: 170, margin: 10 } : { height: 50 }}
        src={`/images/commons/logos/${env.DEFAULT_LOCALE == 'vi' ? 'logo.webp' : 'englook.png'}`}
      />
    </div>
    <div className="cursor-pointer text-white mr-3" onClick={toggleChat}>
      <FontAwesomeIcon icon={faTimes} />
    </div>
  </div>
);

export default ChatHeader;
